
<script setup>

  import { ref } from 'vue';

  import { ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import SimpleDialog from '../dialogs/simple.vue';

  import MapIcon from '../icons/map-icon.vue';

  import { selectedFood } from '../stores/activity-2.js';

  const pinnaclesDialog = ref( null );

  const panoramaDialog = ref( null );

  selectedFood.value = null;

</script>

<template>

  <article>

    <div class="grid grid-rows-2 grid-cols-2 h-view">

      <div class="row-start-1 col-start-1 col-end-3 md:row-end-3 md:col-end-2">

        <img src="../images/activity-2-part-5-b-left.jpg" alt="" aria-hidden="true" class="w-full h-full object-cover" />

      </div>

      <div class="row-start-2 col-start-1 col-end-3 md:row-start-1 md:row-end-3 md:col-start-2 md:col-end-3">

        <img src="../images/activity-2-part-5-b-right.jpg" alt="" aria-hidden="true" class="w-full h-full object-cover" />

      </div>

      <button type="button" @click="event => { selectedFood = 'pinnacles'; pinnaclesDialog.open() }"
      
        class="row-start-1 col-start-1 col-end-3 md:row-end-3 md:col-end-2
        
          group flex items-center justify-center transition-colors focus-visible:bg-black/50 hover:bg-black/25">

        <div class="flex items-center px-10 py-3 gap-5 text-white bg-black/50">

          <MapIcon class="w-14 group-focus-visible:text-amber-300 group-hover:text-amber-300" />

          <div>

            <div class="text-xl">Select</div>

            <div class="text-4xl font-heading uppercase group-focus-visible:underline group-hover:underline">Pinnacles<br />Picnic Grounds</div>

          </div>

        </div>

      </button>

      <button type="button" @click="event => { selectedFood = 'panorama'; panoramaDialog.open() }"
      
        class="row-start-2 col-start-1 col-end-3 md:row-start-1 md:row-end-3 md:col-start-2 md:col-end-3
        
          group flex items-center justify-center transition-colors focus-visible:bg-black/50 hover:bg-black/25">

        <div class="flex items-center px-10 py-3 gap-5 text-white bg-black/50">

          <MapIcon class="w-14 group-focus-visible:text-amber-300 group-hover:text-amber-300" />

          <div>

            <div class="text-xl">Select</div>

            <div class="text-4xl font-heading uppercase group-focus-visible:underline group-hover:underline">Panorama<br />Restaurant</div>

          </div>

        </div>

      </button>

      <img src="../sequences/activity-2-car-0030.png" alt=""
      
        class="hidden md:block row-start-1 row-end-3 col-start-1 col-end-3 w-full h-view object-cover pointer-events-none" />

    </div>

    <SimpleDialog ref="pinnaclesDialog" title="Pinnacles Picnic Grounds" class="max-w-2xl">

      <img src="../images/activity-2-part-5-pinnacles.jpg" alt="A white family eating at a picnic table located in a picnic ground within the woods of Shenandoah National Park." />

      <p class="mt-6 text-neutral-700">

        You arrive at Pinnacles Picnic Grounds but notice something odd again; there are no signs.
        
        Nothing marked "whites only", but also nothing saying you're welcome here.

      </p>

      <p class="mt-6 text-neutral-700">

        Your friend assured you Pinnacles was for the use of both races, so you scan the picnic grounds.

        There are a few groups spread out.

        Mostly white folks, but you see a young Black couple sharing a sandwich on the far side.

        You breathe a sigh of relief.

        Your family was starting to get restless and hungry.

      </p>

      <p class="mt-6 text-neutral-700">

        You park and choose an available table.

        Not too close to the white visitors, but not as far as the young couple.

      </p>

      <div class="flex justify-end mt-6">

        <RouterLink
        
          class="inline-flex items-center gap-4 px-6 py-4 font-bold text-white bg-green-700 transition-colors
          
            hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
        
          to="/activity/2/part/6">

          <span>Continue</span>

          <ArrowRightCircleIcon class="w-8" />

        </RouterLink>

      </div>

    </SimpleDialog>

    <SimpleDialog ref="panoramaDialog" title="Panorama Restaurant" class="max-w-2xl">

      <img src="../images/activity-2-part-5-panorama.jpg" alt="White visitors, five groups sitting at five separate tables, eating in a restaurant in Shenandoah National Park." />

      <p class="mt-6 text-neutral-700">

        Although the main dining room has plenty of empty tables, it's marked "white only."

        You and your family enter through a side door marked "colored."

        This space is much smaller than the main dining room, and it's already full.

        You decide to picnic instead.

      </p>

      <div class="flex justify-end mt-6">

        <RouterLink
        
          class="flex items-center gap-4 px-6 py-4 font-bold text-white bg-green-700 transition-colors
          
            hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
        
          to="/activity/2/part/6">

          <span>Continue</span>

          <ArrowRightCircleIcon class="w-8" />

        </RouterLink>

      </div>

    </SimpleDialog>

  </article>

</template>
